import { storeImage } from '@/utils/idbStore';
import { isString } from '@/utils/isString';
import { getAllUserDesigns } from '@/redux/draft/getters/getAllUserDesigns';
import { StoreState } from '@/redux/types';

const uploadImageObjectUrls = new Map<string, string>();
export const setImageObjectUrl = (id: string, objectURL: string) => {
  const uploadImageObjectUrl = uploadImageObjectUrls.get(id);
  if (isString(uploadImageObjectUrl)) {
    URL.revokeObjectURL(uploadImageObjectUrl);
  }
  uploadImageObjectUrls.set(id, objectURL);
};

export const getImageObjectUrl = (id: string) => uploadImageObjectUrls.get(id);

export const getIdFromFile = ({ name, lastModified, size }: File) =>
  `${name}-${lastModified}-${size}`;

export const getFileObjectUrl = (file: File) => getImageObjectUrl(getIdFromFile(file));

export const persistUpload = (designId: string, objectUrl: string, state: StoreState) => {
  setImageObjectUrl(designId, objectUrl);
  storeImage(designId, objectUrl, () => getAllUserDesigns(state)); // no need to wait for result
};
